/**
 * The "Showing …" sentence under a list. Pure, and the one place the rule
 * lives: **a total is shown only when the server gave one.** Without it the
 * line says how many are on screen and nothing more — "Showing 50", never
 * "Showing 50 of 50" from a page that merely ended.
 */
export interface PagerSummaryInput {
  /** Rows on screen (load-more: everything loaded so far; pages: this page). */
  shown: number;
  /** Server total, when the endpoint returns one. */
  total?: number | null;
  /** First row's 1-based position, for page mode ("Showing 21–40"). */
  from?: number;
  /** Plural noun, e.g. "matters". Omit for a bare count. */
  noun?: string;
}

// The viewer's own grouping (global desk; the India desk pins en-IN).
const fmt = (n: number) => n.toLocaleString();

export function pagerSummary({ shown, total, from, noun }: PagerSummaryInput): string {
  const knownTotal = typeof total === 'number' && Number.isFinite(total) && total >= 0;
  const tail = noun ? ` ${noun}` : '';
  if (shown <= 0) {
    return knownTotal ? `Showing 0 of ${fmt(total as number)}${tail}` : `Showing 0${tail}`;
  }
  const range =
    from !== undefined && from > 0 ? `${fmt(from)}–${fmt(from + shown - 1)}` : fmt(shown);
  return knownTotal
    ? `Showing ${range} of ${fmt(total as number)}${tail}`
    : `Showing ${range}${tail}`;
}
